var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fc-alert" }, [
    _c("div", { staticClass: "fc-alert__container" }, [
      _vm.title
        ? _c(
            "h1",
            { staticClass: "fc-alert__title" },
            [
              _vm._l(_vm.stringParser(_vm.title), function (v, index) {
                return [_vm._v(" " + _vm._s(v)), _c("br", { key: index })]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.subtitle
        ? _c(
            "div",
            { staticClass: "fc-alert__subtitle" },
            [
              _vm._l(_vm.stringParser(_vm.subtitle), function (v, index) {
                return [_vm._v(" " + _vm._s(v)), _c("br", { key: index })]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.imageUrl
        ? _c("div", { staticClass: "fc-alert__image" }, [
            _c("img", { attrs: { src: _vm.imageUrl, alt: _vm.subtitle } }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonText
        ? _c("div", { staticClass: "fc-alert__button" }, [
            _c(
              "button",
              { staticClass: "btn-confirm", on: { click: _vm.confirm } },
              [
                _c("i", { class: "icon icon--" + _vm.buttonIcon }),
                _vm._v(" "),
                _c("span", { staticClass: "btn-confirm__text" }, [
                  _vm._v(_vm._s(_vm.buttonText)),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fc-alert__footer" }, [
      _c("div", { staticClass: "fc-today" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.isClosedToday,
              expression: "isClosedToday",
            },
          ],
          attrs: { id: "close-alert", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.isClosedToday)
              ? _vm._i(_vm.isClosedToday, null) > -1
              : _vm.isClosedToday,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.isClosedToday,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isClosedToday = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isClosedToday = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isClosedToday = $$c
                }
              },
              _vm.updateTodayCookie,
            ],
          },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "close-alert" } }, [
          _vm._v("오늘 하루 보지 않기"),
        ]),
      ]),
      _vm._v(" "),
      _c("button", { staticClass: "btn-close", on: { click: _vm.close } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }